import { AxiosResponse } from "axios";
import { apiClient } from "@/api/apiClient";
import * as Sentry from "@sentry/browser";
import { API_PATHS } from "@/constants/apiPaths";
import {
  VerifySsnRequest,
  VerifySsnResponse,
} from "@/api/vouched/types";

const VouchedAPI = {
  async verifySsn(payload: VerifySsnRequest): Promise<VerifySsnResponse> {
    try {
      const response: AxiosResponse<VerifySsnResponse> = await apiClient.post(
        API_PATHS.VERIFY_SSN,
        payload
      );

      return response.data;
    } catch (error) {
      Sentry.captureException(error);
      // Re-throw the original error so callers can inspect the HTTP status
      // (e.g. 429 rate limiting).
      throw error;
    }
  },
};

export const { verifySsn } = VouchedAPI;
